<template>
  <section>
    <meeting-list :query="query" />
  </section>
</template>

<script>
import MeetingList from '@/components/company/MeetingList'

export default {
  name: 'Meetings',
  components: {
    MeetingList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
